<template>
  <div>
    <p>Marco Eble</p>
    <p><b>Postanschrift:</b></p>
    <address>Buchholzer weg 3<br>
    79350 Sexau<br>
    Deutschland</address>
    <p>
      Plattform der EU-Kommission zur Online-Streitbeilegung: www.ec.europa.eu/consumers/odr
      Wir sind nicht bereit oder verpflichtet, an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
    </p>
  </div>
</template>

<script>
export default {
  name: 'Imprint',
};
</script>

<style lang="less" scoped>
div {
  max-width: 320px;
  margin: 0 auto;
}
</style>
